<template>
  <div>
    <PageAllow controller="SummaryMonthlyStatement" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetime
                type="month"
                v-model="options.summary_month"
                :label="$t('summaryMonthlyStatement.createdMonth')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />

            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherShops v-model="shopsSelected"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="summaryMonthlyStatement"
          :options.sync="options"
          :loading="loading"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-1 px-4 pt-1 sticky-first-col"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.shop_code="{ item }">
            {{ item.shop_name }} / {{ item.shop_code }}
          </template>
          <template v-slot:item.created="{ item }">
            {{ item.created | formatDate }}
          </template>
          <template v-slot:item.summary_date="{ item }">
            {{ item.summary_start_date | formatDate }} - {{ item.summary_end_date | formatDate }}
          </template>
          <template v-slot:item.order_logistics_fee="{ item }">
            {{ $t("Global.money") }}{{ item.order_logistics_fee | formatMoney }}
          </template>
          <template v-slot:item.return_logistics_fee="{ item }">
            {{ $t("Global.money") }}{{ item.return_logistics_fee | formatMoney }}
          </template>
          <template v-slot:item.order_service_charge="{ item }">
            {{ $t("Global.money") }}{{ item.order_service_charge | formatMoney }}
          </template>
          <template v-slot:item.return_service_charge="{ item }">
            {{ $t("Global.money") }}{{ item.return_service_charge | formatMoney }}
          </template>
          <template v-slot:item.summary_fee="{ item }">
            <span class="red--text">
              {{ $t("Global.money") }}{{ (item.need_receivable - item.need_payment) | formatMoney }}
            </span>
          </template>
          <template v-slot:item.need_receivable="{ item }">
            {{ $t("Global.money") }}{{ item.need_receivable | formatMoney }}
          </template>
          <template v-slot:item.need_payment="{ item }">
            {{ $t("Global.money") }}{{ item.need_payment | formatMoney }}
          </template>
          <template v-slot:item.actual_receivable="{ item }">
            {{ $t("Global.money") }}{{ item.actual_receivable | formatMoney }}
          </template>
          <template v-slot:item.actual_payment="{ item }">
            {{ $t("Global.money") }}{{ item.actual_payment | formatMoney }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | statementBillTypeColor"
              :text-color="item.status | statementBillTypeTextColor"
            >
              {{ item.status | statementBillTypeText }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="$permission.permissionAllow('SummaryMonthlyStatement', 'view')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  :href="'/#/summary-monthly-statement/' + (item && item.id ? item.id : 0)"
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("summaryMonthlyStatement.actions.detail") }}
                </v-btn>
              </template>
              <span>{{ $t("summaryMonthlyStatement.actions.detail") }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('SummaryMonthlyStatement', 'reCreate') &&
                item.actions &&
                item.actions.re_create
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="print"
                  class="px-2 me-2 mb-1"
                  @click.stop="reCreate(item.id)"
                >
                  {{ $t("summaryMonthlyStatement.actions.reCreate") }}
                </v-btn>
              </template>
              <span>{{ $t("summaryMonthlyStatement.actions.reCreate") }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('SummaryMonthlyStatement', 'finish') &&
                item.actions &&
                item.actions.over
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="print"
                  class="px-2 me-2 mb-1"
                  @click.stop="finish(item.id)"
                >
                  {{ $t("summaryMonthlyStatement.actions.finish") }}
                </v-btn>
              </template>
              <span>{{ $t("summaryMonthlyStatement.actions.finish") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import consts from "@/consts";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetime from "@/components/plugins/SearcherDatetime"
import SearcherShops from "@/components/plugins/SearcherShops"
import SummaryMonthlyStatement from "@/api/summary_monthly_statement";

const defaultOptions = {
  summary_month: new Date().toISOString().substr(0, 7),
  shop_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetime,
    SearcherShops,
  },

  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("summary-monthly-statement-options")
        ? sessionStorage.getItem("summary-monthly-statement-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    summaryMonthlyStatement: [],
    shopsSelected: null,
  }),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.statementManagement"),
        disabled: false,
        href: "/summary-monthly-statement",
      },
      {
        text: i18n.t("Nav.summaryMonthlyStatement"),
        disabled: true,
        href: "/summary-monthly-statement",
      },
    ],

    headers() {
      let headers = [
        {
          text: i18n.t("summaryMonthlyStatement.Fields.shop", [consts.shopName()]),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("summaryMonthlyStatement.Fields.created"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("summaryMonthlyStatement.Fields.summary_date"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "summary_date",
        },
        {
          text: i18n.t("summaryMonthlyStatement.Fields.order_logistics_fee"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "order_logistics_fee",
        },
      ];
      if (this.settings && this.settings.service_charge_enable) {
        headers.push({
          text: i18n.t("summaryMonthlyStatement.Fields.order_service_charge"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "order_service_charge",
        })
      }
      headers.push({
        text: i18n.t("summaryMonthlyStatement.Fields.return_logistics_fee"),
        align: "end",
        sortable: false,
        class: "text-no-wrap",
        value: "return_logistics_fee",
      })
      if (this.settings && this.settings.service_charge_enable) {
        headers.push({
          text: i18n.t("summaryMonthlyStatement.Fields.return_service_charge"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "return_service_charge",
        })
      }
      headers.push(
        {
          text: i18n.t("summaryMonthlyStatement.Fields.need_receivable"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "need_receivable",
        },
        {
          text: i18n.t("summaryMonthlyStatement.Fields.need_payment"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "need_payment",
        },
        {
          text: i18n.t("summaryMonthlyStatement.Fields.actual_receivable"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "actual_receivable",
        },
        {
          text: i18n.t("summaryMonthlyStatement.Fields.actual_payment"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "actual_payment",
        },
        {
          text: i18n.t("summaryMonthlyStatement.Fields.summary_fee"),
          align: "end",
          sortable: false,
          class: "text-no-wrap",
          value: "summary_fee",
        },
        {
          text: i18n.t("summaryMonthlyStatement.Fields.statement_bill_type"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        })
      return headers;
    },

    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.$commonUtils.loadOptions("summary-monthly-statement", ["shopsSelected"]).then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
    );
  },

  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.shopsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getSummaryMonthlyStatementFromAPI() {
      SummaryMonthlyStatement.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.summaryMonthlyStatement = response.data.summary_monthly_statement;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    reCreate(id) {
      SummaryMonthlyStatement.reCreate({
        summary_monthly_statement_id: id
      }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getSummaryMonthlyStatementFromAPI()
            }
          }.bind(this)
      );
    },
    finish(id) {
      SummaryMonthlyStatement.finishOne({
        summary_monthly_statement_id: id
      }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getSummaryMonthlyStatementFromAPI()
            }
          }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getSummaryMonthlyStatementFromAPI();
        sessionStorage.setItem(
            "summary-monthly-statement-options",
            JSON.stringify(this.options)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
            ? this.shopsSelected.map((shop) => {
              return shop.id;
            })
            : [];
        sessionStorage.setItem(
            "summary-monthly-statement-shopsSelected",
            JSON.stringify(this.shopsSelected)
        );
      },
    },
  },
};
</script>

<style>
</style>